<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        [attr.aria-label]="'general.cancel' | translate"
      >
        <ion-icon
          slot="icon-only"
          aria-hidden="true"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ (isEdit ? 'vehicles.edit_vehicle' : 'vehicles.add_vehicle') | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <form [formGroup]="vehicleForm">
    <ion-grid class="">
      <ion-row>
        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-input
            class="ion-margin-bottom"
            label="{{ 'vehicles.plate' | translate }}"
            label-placement="floating"
            fill="outline"
            mode="md"
            formControlName="plateNumber"
            (ionInput)="onPlateNumberInput($event)"
            [errorText]="getErrorMessage('plateNumber') | translate"
          ></ion-input>
        </ion-col>
        <ion-col
          size="12"
          size-lg="6"
        >
          <ion-select
            label="{{ 'vehicles.type' | translate }}"
            interface="popover"
            label-placement="floating"
            fill="outline"
            mode="md"
            formControlName="type"
            [errorText]="getErrorMessage('type') | translate"
          >
            @for (option of typeOptions; track option.type) {
              <ion-select-option [value]="option.type">{{ option.labelKey | translate }}</ion-select-option>
            }
          </ion-select>
        </ion-col>
      </ion-row></ion-grid
    >
  </form>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
            size="large"
          >
            {{ 'general.save' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
